module.exports = __webpack_public_path__ + "static/agile-77b2cc5b94f96574ccfc4e2e60b9de73.svg";